import { INDEXED_COLORS } from './workbookStyle';
import { type RGB, rgb } from '@libpdf/core';
import Color from 'colorjs.io';

export abstract class BaseExcelColor {
  public abstract getColor(): Color;
  public toHex(): string {
    return this.getColor().toString({ format: 'hex' });
  }
  public toCo(): { color: RGB; opacity: number } {
    const { r, g, b, alpha: a } = this.getColor();
    return { color: rgb(r!, g!, b!), opacity: a ?? 1 };
  }
}

export class ExcelColorIndexed extends BaseExcelColor {
  constructor(public readonly index: number) {
    super();
    if (index < 0 || index > INDEXED_COLORS.length - 1) {
      throw new Error(`Invalid index ${index}`);
    }
  }

  public getColor(): Color {
    return INDEXED_COLORS[this.index]!;
  }
}

// TODO: export class ExcelColorTheme

export class ExcelColor extends BaseExcelColor {
  constructor(public readonly color: Color) {
    super();
  }

  public static fromHex(hex: string): ExcelColor {
    return new ExcelColor(new Color(hex));
  }

  public getColor(): Color {
    return this.color;
  }
}

export const TRANSPARENT = ExcelColor.fromHex('#00000000');
export const BLACK = new ExcelColorIndexed(0);
export const WHITE = new ExcelColorIndexed(1);
